import { render, staticRenderFns } from "./BusinessJoinStep3.vue?vue&type=template&id=b1ff4bc0&"
import script from "./BusinessJoinStep3.vue?vue&type=script&lang=js&"
export * from "./BusinessJoinStep3.vue?vue&type=script&lang=js&"
import style0 from "./BusinessJoinStep3.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports